import consumer from "./consumer"

function findEventSlug () {
    const body = document.getElementsByTagName('body')[0]

    if (body === undefined)
        return null;

    return body.getAttribute('data-event-slug')
}

const pollResultsSub = function(receivedCb) {
    console.log('calling for sub')
    consumer.subscriptions.create({channel: 'PollResultsChannel', event_id: findEventSlug()}, {
        connected() {
            console.log("Connected to the poll results channel!");
        },

        disconnected() {
            // Called when the subscription has been terminated by the server
        },

        received(data) {
            switch(data.status) {
                case "saved":
                    receivedCb(data)
                    break;
                case "open_poll":
                    const url = "/events/"+data.event_slug+"/poll/"+data.question_id+"/results";
                    location.href = url;
                    break;
                default:
                    return false
            }
        }
    });
}

export default pollResultsSub;